import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import { LicenseKey } from '../types';

export const licenseKeyFactory = define<LicenseKey>({
  id: () => faker.string.uuid(),
  key: () => faker.string.uuid(),
  externalId: () => faker.string.numeric({ length: 10 }),
  softwareSeats: () => [],
});
